export const manualDepositWithdraw = {
    manualDeposit: "Manual Deposit V1",
    manualWithDraw: "Manual Withdraw V1",
    from: "From",
    to: "To",
    advanceFilter: "Advance Filter",
    user: "User",
    channel: "Channel",
    amount: "Amount",
    date: "Date",
    approvedBy: "Approved By",
    username: "Username",
    all: "All",
    adminTopup: "ADMIN_TOPUP",
    affiliateDownline: "AFFILIATE_DOWNLINE",
    affiliateCommissions: "AFFILIATE_COMMISSION",
    filter: "Filter",
    cancel: "Cancel",
    refCode: "Reference"
  };
  